export default __webpack_public_path__ + "static/media/2930 knife block C side.dc476e2d.png";